import { DEFAULT_FACTOR_FORM_STATE, type FactorFormState } from '../types/statusFactors';

/**
 * Number of user-visible changes between a draft and its saved state, for the pane footer's
 * "N unsaved changes". Mirrors areFormStatesEqual's field list, but groups fields that read as one
 * edit: the two combine axes, the coverage floor, and the rollup set with its preserved tail.
 * Mode and Show on cards save immediately and are not part of the form state. A new factor
 * (no original) is compared against the blank draft, so it counts the fields the user filled.
 */
export function countUnsavedChanges(local: FactorFormState, original: FactorFormState | null): number {
  const base = original ?? DEFAULT_FACTOR_FORM_STATE;
  const json = (v: unknown) => JSON.stringify(v);
  const changed: boolean[] = [
    local.factorType !== base.factorType,
    local.weight !== base.weight,
    local.name !== base.name,
    local.description !== base.description,
    local.commentRequired !== base.commentRequired,
    local.minCommentLength !== base.minCommentLength,
    local.checkInTrigger !== base.checkInTrigger,
    local.initialStatus !== base.initialStatus,
    local.aggregationMethod !== base.aggregationMethod || local.weighting !== base.weighting,
    local.emptyBehavior !== base.emptyBehavior,
    local.perspectiveDirection !== base.perspectiveDirection,
    local.influenceFloor !== base.influenceFloor,
    local.coverageFloor?.percent !== base.coverageFloor?.percent ||
      local.coverageFloor?.status !== base.coverageFloor?.status,
    local.childPerspective !== base.childPerspective,
    local.preservedMeasureSystemName !== base.preservedMeasureSystemName,
    json(local.checkInSchedule) !== json(base.checkInSchedule),
    json(local.perspectiveFilters) !== json(base.perspectiveFilters),
    json(local.propertyFilters) !== json(base.propertyFilters),
    json(local.filterGroups) !== json(base.filterGroups),
    json(local.rollupSet) !== json(base.rollupSet) ||
      json(local.preservedPopulationSourcesTail) !== json(base.preservedPopulationSourcesTail),
  ];
  return changed.filter(Boolean).length;
}
